<template>
  <div id="app">
    <router-view />
    
    <AlertContainer/>
  </div>
</template>

<script>
import AlertContainer from "./components/AlertContainer.vue";
import { themes } from './themes.js';

export default {
  components: { AlertContainer },
  data() {
    return {
      colorSchemeQuery: null,
      temaEscuroPadrao: 'madeira e palha',
      temaClaroPadrao: 'ninho de palha'
    };
  },
  methods: {
    setTheme(themeName) {
      const theme = themes[themeName];
      if (!theme) return;
      for (const [key, value] of Object.entries(theme)) {
        this.$el.style.setProperty(key, value);
      }
    },
    detectColorScheme(event) {
      const novoTema = event.matches ? this.temaEscuroPadrao : this.temaClaroPadrao;
      this.setTheme(novoTema);
    }
  },
  mounted() {
    // Configuração de tema existente
    if (window.matchMedia) {
      this.colorSchemeQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const temaInicial = this.colorSchemeQuery.matches ? this.temaEscuroPadrao : this.temaClaroPadrao;
      this.setTheme(temaInicial);
      this.colorSchemeQuery.addEventListener('change', this.detectColorScheme);
    } else {
      this.setTheme(this.temaEscuroPadrao);
    }
    
    // Remova os listeners de hashchange
  },
  beforeDestroy() {
    if (this.colorSchemeQuery) {
      this.colorSchemeQuery.removeEventListener('change', this.detectColorScheme);
    }
    // Remova removeEventListener('hashchange')
  }
};
</script>

<style>
.admin-link {
  position: fixed;
  bottom: 5px;
  left: 5px;
  opacity: 0.3;
  z-index: 9999;
}
.admin-link a {
  color: var(--text-main);
  text-decoration: none;
  font-size: 10px;
}
.admin-link:hover {
  opacity: 1;
}
</style>